import React from 'react';

import HeadWrapper from '../../components/HeadWrapper';
import { ErrorPage } from '@zillow/zrs-zillow-offers';
import { StyledPage } from './styles';

const NotFoundPage = () => (
  <StyledPage className="NotFoundPage">
    <HeadWrapper title="Page not found" />
    <ErrorPage homePageText="Return to Zillow Rental Manager" homePageUrl="https://www.zillow.com/rental-manager" />
  </StyledPage>
);

export default NotFoundPage;
